"use client";

import { useAuthStore } from "../stores/useAuthStore";

function firstNameOf(fullName: string): string {
    return fullName.trim().split(/\s+/)[0] ?? "";
}

/**
 * Hook completo de autenticação — estado + ações. Use quando precisar de
 * login/logout (ex.: formulários). Para só ler o estado em muitos lugares,
 * prefira os hooks atômicos abaixo, que re-renderizam menos.
 */
export function useAuth() {
    const user = useAuthStore((state) => state.user);
    const status = useAuthStore((state) => state.status);
    const login = useAuthStore((state) => state.login);
    const loginWithSocial = useAuthStore((state) => state.loginWithSocial);
    const logout = useAuthStore((state) => state.logout);

    return {
        user,
        status,
        isAuthenticated: status === "authenticated",
        login,
        loginWithSocial,
        logout,
    };
}

/** O usuário autenticado (ou null). Re-renderiza só quando o user muda. */
export function useAuthUser() {
    return useAuthStore((state) => state.user);
}

/** Primeiro nome do usuário (ou null) — para saudações no header etc. */
export function useFirstName(): string | null {
    return useAuthStore((state) => (state.user ? firstNameOf(state.user.name) : null));
}
